import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { ChangePassword } from "../../../actions/UserActions";
import {
  SaveUserSettings
} from "../../../actions/UserSettingActions";
const UserProfileView = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo.value);
  const loginInfo = useSelector((state) => state.loginInfo.value);
  const [currentView, updateCurrentView] = useState("roles");
  const [password1, updatePassword1] = useState("");
  const [password2, updatePassword2] = useState("");
  const [passwordError, updatePasswordError] = useState("");
  const [keepQuickSearch, setKeepQuickSearch] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [hasError] = useState(false);
  const [errorMessage] = useState("");
  const [currentFontSize, updateCurrentFontSize] = useState(0);
  const [currentFontSizeName, updateCurrentFontSizeName] = useState("Large");
  const [quickSearchPriorityValue, updateQuickSearchPriorityValue] = useState("0");
  const [quickSearchPriorityText, updateQuickSearchPriorityText] = useState("0");
  const [firstName, updateFirstName] = useState("");
  const [lastName, updateLastName] = useState("");
  const [email, updateEmail] = useState("");
  const [sendEmailNotifications] = useState(false);
  const [currentUserLicenseLevel] = useState(0);
  const [defaultHome, updateDefaultHome] = useState("Active Documents");
  const [defaultTrinFormsHome, updateDefaultTrinFormsHome] = useState("Inbox");
  const [defaultApp, updateDefaultApp] = useState("TrinDocs");
  const [betaActiveDocuments, updateBetaActiveDocuments] = useState(false);
  useEffect(() => {
    document.title = "TrinDocs - User Profile";
    if (userInfo.loaded) {
      console.log(userInfo.userSettings);
      updateDefaultApp(userInfo.userSettings.defaultApp);
    }
    if (loginInfo.loggedIn) {
      let userSettings = loginInfo.userSettings;
      let fontSize = "1";
      let fontSizeName = "Small";
      let quickSearchPriority = "0";
      let quickSearchLabel = "Values -> Document Id";
      let defaultHomePage = "Inbox";
      let defaultTrinFormsHomePage = "Inbox";
      let defaultApp2 = "TrinDocs";
      console.log(userInfo.userSettings.fontSizeMode);
      let fontSizeSetting = userInfo.userSettings.fontSizeMode;
      if (fontSizeSetting) {
        if (fontSizeSetting === "0") {
          fontSize = "0";
          fontSizeName = "Small";
        }
        if (fontSizeSetting === "1") {
          fontSize = "1";
          fontSizeName = "Large";
        }
      }
      let quickSearchSetting = userInfo.userSettings.quickSearchPriority;
      if (quickSearchSetting) {
        if (quickSearchSetting === "0") {
          quickSearchPriority = "0";
          quickSearchLabel = "Values -> Document Id";
        }
        if (quickSearchSetting === "1") {
          quickSearchPriority = "1";
          quickSearchLabel = "Document Id -> Values";
        }
      }
      let defaultHomePageSetting = userInfo.userSettings.defaultHome;
      if (defaultHomePageSetting) {
        defaultHomePage = defaultHomePageSetting;
      }
      let defaultTrinFormsHomePageSetting = userSettings.find((x) => x.name === "default_trinforms_home");
      if (defaultTrinFormsHomePageSetting) {
        defaultTrinFormsHomePage = defaultTrinFormsHomePageSetting.value;
      }
      let defaultAppSetting = userSettings.find((x) => x.name === "default_app");
      if (defaultAppSetting) {
        defaultApp2 = defaultAppSetting.value;
      }
      if (userInfo.userSettings.keepQuickSearch !== void 0) {
        console.log(userInfo);
        if (userInfo.userSettings.keepQuickSearch.toUpperCase() === "TRUE") {
          setKeepQuickSearch(true);
        } else {
          setKeepQuickSearch(false);
        }
      }
      if (userInfo.userSettings.betaActiveDocuments !== void 0) {
        if (userInfo.userSettings.betaActiveDocuments.toUpperCase() === "TRUE") {
          updateBetaActiveDocuments(true);
        } else {
          updateBetaActiveDocuments(false);
        }
      }
      updateCurrentFontSize(fontSize);
      updateCurrentFontSizeName(fontSizeName);
      updateQuickSearchPriorityText(quickSearchLabel);
      updateQuickSearchPriorityValue(quickSearchPriority);
      updateDefaultHome(defaultHomePage);
      updateDefaultApp(defaultApp2);
      updateFirstName(loginInfo.firstName);
      updateLastName(loginInfo.lastName);
      updateEmail(loginInfo.email);
    }
  }, [userInfo, loginInfo]);
  const setFontSize = (size) => {
    let fontSize = "";
    let fontSizeName = "";
    if (size === 0) {
      fontSize = "0";
      fontSizeName = "Small";
    } else {
      fontSize = "1";
      fontSizeName = "Large";
    }
    updateCurrentFontSize(fontSize);
    updateCurrentFontSizeName(fontSizeName);
    setIsDirty(true);
  };
  const onChangeFirstName = (e) => {
    updateFirstName(e.target.value);
    setIsDirty(true);
  };
  const onChangeLastName = (e) => {
    updateLastName(e.target.value);
    setIsDirty(true);
  };
  const switchView = (newView) => {
    updateCurrentView(newView);
  };
  const onChangePassword1 = (e) => {
    updatePassword1(e.target.value);
  };
  const onChangePassword2 = (e) => {
    updatePassword2(e.target.value);
  };
  const onSaveClick = () => {
    console.log(keepQuickSearch);
    SaveUserSettings(
      firstName,
      lastName,
      currentFontSize,
      quickSearchPriorityValue.toString(),
      sendEmailNotifications,
      defaultHome,
      "",
      //defaultTrinFormsHome,
      defaultApp,
      keepQuickSearch,
      betaActiveDocuments,
      dispatch
    );
  };
  const onChangePasswordClick = () => {
    if (password1.length === 0) {
      updatePasswordError("Password is required");
    } else if (password1.length <= 4) {
      updatePasswordError("Password must be greater than four characters");
    } else if (password1 !== password2) {
      updatePasswordError("Passwords don't match");
    } else {
      updatePasswordError("");
      console.log(loginInfo);
      ChangePassword(loginInfo.userId, password2, dispatch);
    }
  };
  const setDefaultHome = (homeValue) => {
    updateDefaultHome(homeValue);
    setIsDirty(true);
  };
  const setDefaultTrinFormsHome = (homeValue) => {
    updateDefaultTrinFormsHome(homeValue);
    setIsDirty(true);
  };
  const setDefaultApp = (appValue) => {
    updateDefaultApp(appValue);
    setIsDirty(true);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "d-flex flex-row flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "p-4 w-50" }, /* @__PURE__ */ React.createElement("div", { id: "userInfo", className: "card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-user" }), " User Profile"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginTop: "8px" } }, /* @__PURE__ */ React.createElement("div", { className: "form-group col-6" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtFirstName" }, "First Name"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      className: "form-control",
      id: "txtFirstName",
      value: firstName,
      onChange: onChangeFirstName,
      placeholder: "first name"
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "form-group col-6" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtLastName" }, "Last Name"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      className: "form-control",
      id: "txtLastName",
      value: lastName,
      onChange: onChangeLastName,
      placeholder: "last name"
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginTop: "16px" } }, /* @__PURE__ */ React.createElement("div", { className: "form-group col-6" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtEmail" }, "Email Address"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      className: "form-control",
      id: "txtEmail",
      readOnly: true,
      value: email,
      placeholder: "last name"
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginTop: "16px" } }, /* @__PURE__ */ React.createElement("div", { className: "col-5" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtUserName" }, "Font Size"), /* @__PURE__ */ React.createElement(Dropdown, null, /* @__PURE__ */ React.createElement(
    Dropdown.Toggle,
    {
      id: "ddLicenseLevel"
    },
    currentFontSizeName
  ), /* @__PURE__ */ React.createElement(Dropdown.Menu, null, /* @__PURE__ */ React.createElement(
    Dropdown.Item,
    {
      href: "",
      onClick: () => setFontSize(0)
    },
    "Small"
  ), /* @__PURE__ */ React.createElement(
    Dropdown.Item,
    {
      href: "",
      onClick: () => setFontSize(1)
    },
    "Large"
  )))), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtUserName" }, "Quick Search Priority"), /* @__PURE__ */ React.createElement(Dropdown, null, /* @__PURE__ */ React.createElement(
    Dropdown.Toggle,
    {
      id: "ddLicenseLevel"
    },
    quickSearchPriorityValue === "0" ? "Values -> Document Id" : "Document Id -> Values"
  ), /* @__PURE__ */ React.createElement(Dropdown.Menu, null, /* @__PURE__ */ React.createElement(
    Dropdown.Item,
    {
      href: "",
      onClick: () => {
        updateQuickSearchPriorityValue("0");
        setIsDirty(true);
      }
    },
    "Values -> Document Id"
  ), /* @__PURE__ */ React.createElement(
    Dropdown.Item,
    {
      href: "",
      onClick: () => {
        updateQuickSearchPriorityValue("1");
        setIsDirty(true);
      }
    },
    "Document Id -> Values"
  ))))), /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginTop: "16px" } }, /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", null, "Default Home Page"), /* @__PURE__ */ React.createElement(Dropdown, null, /* @__PURE__ */ React.createElement(
    Dropdown.Toggle,
    {
      id: "dddefaultHome",
      className: "btn-success"
    },
    defaultHome
  ), /* @__PURE__ */ React.createElement(Dropdown.Menu, null, /* @__PURE__ */ React.createElement(
    Dropdown.Item,
    {
      href: "",
      onClick: () => setDefaultHome("Inbox")
    },
    "Inbox"
  ), /* @__PURE__ */ React.createElement(
    Dropdown.Item,
    {
      href: "",
      onClick: () => setDefaultHome("Active Documents")
    },
    "Active Documents"
  ))))), /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginTop: "16px" } }, /* @__PURE__ */ React.createElement("div", { className: "col-5" }, /* @__PURE__ */ React.createElement("label", null, "Keep Quick Search"), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "form-check-input",
      type: "checkbox",
      checked: keepQuickSearch,
      style: { marginLeft: "12px" },
      onChange: (e) => {
        setKeepQuickSearch(e.target.checked);
        setIsDirty(true);
      }
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "col-5" }, /* @__PURE__ */ React.createElement("label", null, "Use Beta Active Documents Page"), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "form-check-input",
      type: "checkbox",
      checked: betaActiveDocuments,
      style: { marginLeft: "12px" },
      onChange: (e) => {
        updateBetaActiveDocuments(e.target.checked);
        setIsDirty(true);
      }
    }
  ))))), /* @__PURE__ */ React.createElement("div", null, hasError && /* @__PURE__ */ React.createElement("div", { className: "alert alert-danger", style: { marginTop: "16px" } }, errorMessage)), /* @__PURE__ */ React.createElement("div", { id: "userPills", className: "mt-3" }, /* @__PURE__ */ React.createElement("ul", { className: "nav nav-pills" }, currentUserLicenseLevel < 5 && /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, /* @__PURE__ */ React.createElement(
    "span",
    {
      className: `nav-link ${currentView === "password" ? "active" : ""}`,
      style: { cursor: "pointer" },
      onClick: () => switchView("password")
    },
    "Change Password"
  )), isDirty && /* @__PURE__ */ React.createElement("li", { className: "nav_item" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn btn-success",
      onClick: onSaveClick,
      style: { marginLeft: "30px" }
    },
    /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-save" }),
    "  Save Changes"
  )))), currentView === "password" && /* @__PURE__ */ React.createElement(
    "div",
    {
      id: "Aliases",
      className: "card",
      style: {
        gridColumnStart: "1",
        gridColumnEnd: "3",
        gridRow: "3 / 3",
        margin: "16px"
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Change Password"),
    /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "form-group col-6" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "pwdPassword1" }, "New Password"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "password",
        value: password1,
        onChange: onChangePassword1,
        className: "form-control",
        id: "pwdPassword1",
        placeholder: "Password"
      }
    ))), /* @__PURE__ */ React.createElement("div", { style: { marginTop: "20px" } }, /* @__PURE__ */ React.createElement("div", { className: "form-group col-6" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "pwdPassword2" }, "Confirm New Password"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "password",
        value: password2,
        onChange: onChangePassword2,
        className: "form-control",
        id: "pwdPassword2",
        placeholder: "Password"
      }
    ), passwordError.length > 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        style: { marginTop: "10px" },
        className: "alert alert-danger",
        role: "alert"
      },
      passwordError
    ))), /* @__PURE__ */ React.createElement(
      "button",
      {
        onClick: onChangePasswordClick,
        style: { marginTop: "20px" },
        className: "btn btn-primary"
      },
      "Change Password"
    ))
  )));
};
export default UserProfileView;
